import { ACTION_TYPE, JobBuilderContext } from "context/jobBuilderContext";
import { ChangeEvent, ReactNode, useContext, useState } from "react";
import { TOAST_TYPE, ToastContext } from "context/toastContext";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import TextField from "@mui/material/TextField";
import { Vehicle } from "types/Vehicle";
import { useTranslation } from "react-i18next";

interface VerifyVINDialogProps {
  open: boolean;
  setOpen: (value: boolean) => void;
  charactersToVerify: number;
  vehicle: Vehicle;
}

const VerifyVINDialog = ({
  open,
  setOpen,
  charactersToVerify,
  vehicle,
}: VerifyVINDialogProps): ReactNode => {
  const { t } = useTranslation();
  const displayToast = useContext(ToastContext);
  const { dispatch } = useContext(JobBuilderContext);
  const [valueToMatch, setValueToMatch] = useState<string>("");
  const handleClose = () => {
    setOpen(false);
  };

  const handeVerifyVIN = () => {
    const result = vehicle.vin.slice(-charactersToVerify);
    const numberOfChars = result.toUpperCase();
    if (valueToMatch && valueToMatch === numberOfChars) {
      setOpen(false);
      dispatch({ type: ACTION_TYPE.SET_VEHICLE, payload: vehicle });
    } else if (valueToMatch && valueToMatch != numberOfChars) {
      displayToast({
        type: TOAST_TYPE.ERROR,
        message: `The VIN provided does not match our records`,
      });
    }
  };

  const handleChange = (e: ChangeEvent<HTMLInputElement>) => {
    setValueToMatch(e.target.value.toUpperCase());
  };

  return (
    <Dialog open={open} onClose={handleClose}>
      <DialogTitle>{t("dialogs.vin_verify.title", { ns: "jobs" })}</DialogTitle>
      <DialogContent>
        <DialogContentText>
          {t("dialogs.vin_verify.description", {
            ns: "jobs",
            charactersToVerify: charactersToVerify,
          })}
        </DialogContentText>
        <TextField
          autoFocus
          required
          margin="dense"
          id="match"
          label={`Enter last ${charactersToVerify} characters of VIN`}
          type="text"
          fullWidth
          variant="standard"
          onChange={handleChange}
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose}>Cancel</Button>
        <Button onClick={handeVerifyVIN}>Verify</Button>
      </DialogActions>
    </Dialog>
  );
};
export default VerifyVINDialog;
